import $ from 'jquery';

$(function () {
    const $app = $('#coc-app');
    if (!$app.length) return;

    // Currency configs & conversion factors relative to UAH
    const currencyConfigs = {
        UAH: { symbol: '₴', rate: 1.0, fuelGas: 58, fuelDiesel: 55, fuelLpg: 34, fuelElec: 4.32, priceMax: 3000000, priceStep: 10000 },
        USD: { symbol: '$', rate: 41.5, fuelGas: 1.40, fuelDiesel: 1.33, fuelLpg: 0.82, fuelElec: 0.10, priceMax: 80000, priceStep: 500 },
        EUR: { symbol: '€', rate: 45.0, fuelGas: 1.65, fuelDiesel: 1.55, fuelLpg: 0.90, fuelElec: 0.15, priceMax: 75000, priceStep: 500 },
        PLN: { symbol: 'zł', rate: 10.5, fuelGas: 6.60, fuelDiesel: 6.45, fuelLpg: 3.20, fuelElec: 0.85, priceMax: 300000, priceStep: 1000 },
        GBP: { symbol: '£', rate: 53.0, fuelGas: 1.45, fuelDiesel: 1.50, fuelLpg: 0.85, fuelElec: 0.28, priceMax: 65000, priceStep: 500 },
        CHF: { symbol: 'Fr.', rate: 48.0, fuelGas: 1.80, fuelDiesel: 1.90, fuelLpg: 1.10, fuelElec: 0.30, priceMax: 75000, priceStep: 500 },
        CAD: { symbol: 'C$', rate: 30.0, fuelGas: 1.55, fuelDiesel: 1.60, fuelLpg: 0.90, fuelElec: 0.15, priceMax: 100000, priceStep: 500 },
        CZK: { symbol: 'Kč', rate: 1.80, fuelGas: 38.0, fuelDiesel: 37.0, fuelLpg: 17.0, fuelElec: 6.0, priceMax: 1800000, priceStep: 5000 }
    };

    const textMoreCurrencies = $app.data('text-more-currencies') || 'Ще валюти';
    const textMoreShort = $app.data('text-more-short') || 'Ще';

    let activeCurrency = $app.data('currency') || 'UAH';
    if (!currencyConfigs[activeCurrency]) {
        activeCurrency = 'UAH';
    }
    let activeFuelType = 'gasoline';

    // Archetype Presets (Base values in UAH)
    const presets = {
        economy: {
            priceUah: 280000,
            years: 4,
            deprec: 8,
            mileage: 15000,
            fuelType: 'gasoline',
            consumption: 7.5,
            insUah: 3500,
            maintUah: 25000,
            parkingMonthlyUah: 1500,
            taxiTripUah: 150,
            taxiTripsDay: 1.5
        },
        crossover: {
            priceUah: 900000,
            years: 4,
            deprec: 12,
            mileage: 18000,
            fuelType: 'gasoline',
            consumption: 9.0,
            insUah: 30000,
            maintUah: 40000,
            parkingMonthlyUah: 3000,
            taxiTripUah: 200,
            taxiTripsDay: 2.0
        },
        new: {
            priceUah: 1850000,
            years: 3,
            deprec: 18,
            mileage: 20000,
            fuelType: 'gasoline',
            consumption: 10.5,
            insUah: 75000,
            maintUah: 60000,
            parkingMonthlyUah: 5000,
            taxiTripUah: 300,
            taxiTripsDay: 2.5
        },
        ev: {
            priceUah: 1000000,
            years: 4,
            deprec: 14,
            mileage: 20000,
            fuelType: 'electric',
            consumption: 17.0,
            insUah: 25000,
            maintUah: 18000,
            parkingMonthlyUah: 2500,
            taxiTripUah: 180,
            taxiTripsDay: 2.0
        }
    };

    function formatNumber(num) {
        return Math.round(num).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    }

    function formatCurrency(num) {
        const cfg = currencyConfigs[activeCurrency];
        return `${formatNumber(num)} ${cfg.symbol}`;
    }

    function convertFromUah(valUah) {
        const rate = currencyConfigs[activeCurrency].rate;
        return valUah / rate;
    }

    function applyPreset(presetKey) {
        const p = presets[presetKey];
        if (!p) return;

        const rate = currencyConfigs[activeCurrency].rate;
        const price = Math.round(p.priceUah / rate);
        const ins = Math.round(p.insUah / rate);
        const maint = Math.round(p.maintUah / rate);
        const parking = Math.round(p.parkingMonthlyUah / rate);
        const taxiTrip = Math.round(p.taxiTripUah / rate);

        $('#coc-price-input').val(price);
        $('#coc-price-range').val(price);

        $('#coc-years-range').val(p.years);
        $('#coc-years-display').text(`${p.years} ${$app.data('unit-year') || 'y'}`);

        $('#coc-deprec-range').val(p.deprec);
        $('#coc-deprec-display').text(`${p.deprec}% / ${$app.data('unit-year') || 'y'}`);

        $('#coc-mileage-input').val(p.mileage);
        $('#coc-mileage-range').val(p.mileage);

        activeFuelType = p.fuelType;
        $('#coc-fuel-type button').removeClass('active');
        $(`#coc-fuel-type button[data-type="${activeFuelType}"]`).addClass('active');
        updateFuelUnitsAndDefaultPrice();

        $('#coc-consumption-input').val(p.consumption);

        $('#coc-insurance-input').val(ins);
        $('#coc-insurance-range').val(ins);

        $('#coc-maint-input').val(maint);
        $('#coc-maint-range').val(maint);

        $('#coc-parking-input').val(parking);
        $('#coc-parking-range').val(parking);

        $('#coc-taxi-trip-input').val(taxiTrip);
        $('#coc-taxi-trips-day').val(p.taxiTripsDay);

        calculate();
    }

    function updateFuelUnitsAndDefaultPrice() {
        const cfg = currencyConfigs[activeCurrency];
        let defaultPrice = cfg.fuelGas;
        let unitText = $app.data('unit-consumption') || 'л/100 км';
        let unitVolume = $app.data('unit-liter') || 'л';

        if (activeFuelType === 'diesel') {
            defaultPrice = cfg.fuelDiesel;
        } else if (activeFuelType === 'lpg') {
            defaultPrice = cfg.fuelLpg;
        } else if (activeFuelType === 'electric') {
            defaultPrice = cfg.fuelElec;
            unitText = $app.data('unit-consumption-electric') || 'кВт·год/100 км';
            unitVolume = $app.data('unit-kwh') || 'кВт·год';
        }

        const priceUnit = `${cfg.symbol}/${unitVolume}`;

        $('#coc-consumption-unit').text(unitText);
        const fuelPriceBase = $app.data('fuel-price-label') || $('#coc-fuel-price-label').data('orig-text') || 'Ціна пального';
        $('#coc-fuel-price-label').text(`${fuelPriceBase} (${priceUnit})`);
        $('#coc-fuel-price-unit').text(priceUnit);
        $('#coc-fuel-price-input').val(defaultPrice);
    }

    function updateCurrencyUI() {
        const cfg = currencyConfigs[activeCurrency];
        $('.coc-currency-symbol:not(#coc-fuel-price-unit)').text(cfg.symbol);

        // Adjust ranges max and step
        $('#coc-price-range').attr('max', cfg.priceMax).attr('step', cfg.priceStep);
        $('#coc-price-input').attr('max', cfg.priceMax * 3).attr('step', cfg.priceStep);

        const currentActivePreset = $('#coc-presets button.active').data('preset') || 'crossover';
        applyPreset(currentActivePreset);
    }

    function calculate() {
        const cfg = currencyConfigs[activeCurrency];
        const unitKm = $app.data('unit-km') || 'км';
        const unitMonth = $app.data('unit-month') || 'міс';
        const unitYear = $app.data('unit-year') || 'рік';

        const purchasePrice = parseFloat($('#coc-price-input').val()) || 0;
        const years = parseInt($('#coc-years-range').val(), 10) || 1;
        const deprecRate = (parseFloat($('#coc-deprec-range').val()) || 0) / 100;
        const annualMileage = parseFloat($('#coc-mileage-input').val()) || 0;
        const consumption = parseFloat($('#coc-consumption-input').val()) || 0;
        const fuelPrice = parseFloat($('#coc-fuel-price-input').val()) || 0;
        const annualIns = parseFloat($('#coc-insurance-input').val()) || 0;
        const annualMaint = parseFloat($('#coc-maint-input').val()) || 0;
        const monthlyParking = parseFloat($('#coc-parking-input').val()) || 0;

        const taxiTripCost = parseFloat($('#coc-taxi-trip-input').val()) || 0;
        const taxiTripsPerDay = parseFloat($('#coc-taxi-trips-day').val()) || 0;

        // 1. Depreciation Calculation (Compound residual value over N years)
        const residualValue = purchasePrice * Math.pow(1 - deprecRate, years);
        const totalDeprecLoss = Math.max(0, purchasePrice - residualValue);
        const annualDeprec = totalDeprecLoss / years;

        // 2. Fuel / Energy Calculation
        const annualFuel = (annualMileage / 100) * consumption * fuelPrice;

        // 3. Operating Costs
        const annualParking = monthlyParking * 12;

        // 4. Totals
        const totalAnnual = annualDeprec + annualFuel + annualIns + annualMaint + annualParking;
        const totalTco = totalAnnual * years;
        const realMonthly = totalAnnual / 12;
        const costPerKm = annualMileage > 0 ? totalAnnual / annualMileage : 0;

        // Update KPIs
        $('#coc-kpi-km').text(`${costPerKm.toFixed(2)} ${cfg.symbol}/${unitKm}`);
        $('#coc-kpi-month').text(`${formatNumber(realMonthly)} ${cfg.symbol}/${unitMonth}`);
        $('#coc-kpi-year').text(`${formatNumber(totalAnnual)} ${cfg.symbol}/${unitYear}`);
        $('#coc-kpi-total').text(`${formatNumber(totalTco)} ${cfg.symbol}`);
        const kpiTotalLabel = $app.data('kpi-total-label') || 'TCO';
        $('#coc-kpi-total-label').text(`${kpiTotalLabel} (${years} ${unitYear}):`);

        // Cost Breakdown percentages
        const pDeprec = totalAnnual > 0 ? Math.round((annualDeprec / totalAnnual) * 100) : 0;
        const pFuel = totalAnnual > 0 ? Math.round((annualFuel / totalAnnual) * 100) : 0;
        const pMaint = totalAnnual > 0 ? Math.round((annualMaint / totalAnnual) * 100) : 0;
        const pIns = totalAnnual > 0 ? Math.round((annualIns / totalAnnual) * 100) : 0;
        const pPark = Math.max(0, 100 - (pDeprec + pFuel + pMaint + pIns));

        $('#coc-bar-deprec').css('width', `${pDeprec}%`);
        $('#coc-bar-fuel').css('width', `${pFuel}%`);
        $('#coc-bar-maint').css('width', `${pMaint}%`);
        $('#coc-bar-ins').css('width', `${pIns}%`);
        $('#coc-bar-park').css('width', `${pPark}%`);

        $('#coc-val-deprec').text(`${formatCurrency(annualDeprec)} (${pDeprec}%)`);
        $('#coc-val-fuel').text(`${formatCurrency(annualFuel)} (${pFuel}%)`);
        $('#coc-val-maint').text(`${formatCurrency(annualMaint)} (${pMaint}%)`);
        $('#coc-val-ins').text(`${formatCurrency(annualIns)} (${pIns}%)`);
        $('#coc-val-park').text(`${formatCurrency(annualParking)} (${pPark}%)`);

        // 5. Taxi / Rideshare Comparison
        const monthlyTaxi = taxiTripsPerDay * 30 * taxiTripCost;
        const diff = Math.abs(realMonthly - monthlyTaxi);
        $('#coc-taxi-monthly-val').text(formatCurrency(monthlyTaxi));

        if (realMonthly > monthlyTaxi) {
            $('#coc-taxi-verdict-badge').text($app.data('comp-taxi-cheaper') || 'Таксі вигідніше').attr('class', 'badge bg-warning text-white font-size-11');
            $('#coc-taxi-diff-val').text(`+${formatCurrency(diff)} / ${unitMonth}`).attr('class', 'fw-bold text-danger');
        } else {
            $('#coc-taxi-verdict-badge').text($app.data('comp-car-cheaper') || 'Власне авто вигідніше').attr('class', 'badge bg-success text-white font-size-11');
            $('#coc-taxi-diff-val').text(`-${formatCurrency(diff)} / ${unitMonth}`).attr('class', 'fw-bold text-success');
        }

        // 6. Opportunity Cost in Military OVDP Bonds (15% annual compound yield, 5 years)
        // Investing the monthly depreciation & maintenance savings
        const monthlyInvest = (annualDeprec + annualMaint) / 12;
        const r = 0.15 / 12;
        const nMonths = 60; // 5 years
        const fv = monthlyInvest * ((Math.pow(1 + r, nMonths) - 1) / r);

        $('#coc-invest-5yr-val').text(`+${formatCurrency(fv)}`);
    }

    // Event Listeners: 2-way range and number inputs
    $('#coc-price-range').on('input', function () {
        $('#coc-price-input').val($(this).val());
        calculate();
    });
    $('#coc-price-input').on('input', function () {
        $('#coc-price-range').val($(this).val());
        calculate();
    });

    $('#coc-years-range').on('input', function () {
        const val = $(this).val();
        $('#coc-years-display').text(`${val} ${$app.data('unit-year') || 'y'}`);
        calculate();
    });

    $('#coc-deprec-range').on('input', function () {
        const val = $(this).val();
        $('#coc-deprec-display').text(`${val}% / ${$app.data('unit-year') || 'y'}`);
        calculate();
    });

    $('#coc-mileage-range').on('input', function () {
        $('#coc-mileage-input').val($(this).val());
        calculate();
    });
    $('#coc-mileage-input').on('input', function () {
        $('#coc-mileage-range').val($(this).val());
        calculate();
    });

    $('#coc-consumption-input, #coc-fuel-price-input').on('input', calculate);

    $('#coc-insurance-range').on('input', function () {
        $('#coc-insurance-input').val($(this).val());
        calculate();
    });
    $('#coc-insurance-input').on('input', function () {
        $('#coc-insurance-range').val($(this).val());
        calculate();
    });

    $('#coc-maint-range').on('input', function () {
        $('#coc-maint-input').val($(this).val());
        calculate();
    });
    $('#coc-maint-input').on('input', function () {
        $('#coc-maint-range').val($(this).val());
        calculate();
    });

    $('#coc-parking-range').on('input', function () {
        $('#coc-parking-input').val($(this).val());
        calculate();
    });
    $('#coc-parking-input').on('input', function () {
        $('#coc-parking-range').val($(this).val());
        calculate();
    });

    $('#coc-taxi-trip-input, #coc-taxi-trips-day').on('input', calculate);

    // Preset selection
    $(document).on('click', '.coc-preset-btn', function () {
        $('.coc-preset-btn').removeClass('active');
        $(this).addClass('active');
        applyPreset($(this).data('preset'));
    });

    // Currency selection (Direct tabs)
    $(document).on('click', '#coc-currency-tabs > button[data-currency]', function () {
        $('#coc-currency-tabs button').removeClass('active');
        $(this).addClass('active');
        $('.coc-more-currencies-btn').removeClass('active');
        $('.coc-currency-dropdown-item').removeClass('active');
        $('#coc-active-custom-currency').html(`
            <span class="d-none d-sm-inline">${textMoreCurrencies}</span>
            <span class="d-sm-none">${textMoreShort}</span>
        `);

        activeCurrency = $(this).data('currency');
        updateCurrencyUI();
    });

    // Currency selection (Dropdown items)
    $(document).on('click', '.coc-currency-dropdown-item', function (e) {
        e.preventDefault();
        const selCurr = $(this).data('currency');
        const selSymbol = $(this).data('symbol') || '$';

        $('#coc-currency-tabs > button[data-currency]').removeClass('active');
        $('.coc-currency-dropdown-item').removeClass('active');
        $(this).addClass('active');

        $('.coc-more-currencies-btn').addClass('active');
        $('#coc-active-custom-currency').text(`${selSymbol} ${selCurr}`);

        activeCurrency = selCurr;
        updateCurrencyUI();
    });

    // Fuel Type selection
    $(document).on('click', '#coc-fuel-type button', function () {
        $('#coc-fuel-type button').removeClass('active');
        $(this).addClass('active');
        activeFuelType = $(this).data('type');
        updateFuelUnitsAndDefaultPrice();
        calculate();
    });

    // Initial calculation
    updateCurrencyUI();
});

